module.exports = __webpack_public_path__ + "static/img/demo-dialog-1.e419857.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/demo-dialog-1.png
// module id = p1h1
// module chunks = 1